import { Trascodifica, RichiestaMutuoRichiedenteImpegno, Comune } from "./";

export class RichiestaMutuoRichiedente {
  id: number;
	dataCreazione: Date;
	dataModifica: Date;
	dataNascita: Date;
	dataAssunzione: Date;
	dataRilascio: Date;
	cognome: String;
	nome: String;
	mail: String;
	telefono: String;
	residenza: String;
	luogoNascita: String;
	codiceFiscale: String;
	numero: String;
	note: String;
	redditoLordo: number;
	imposte: number;
	importoAltriRedditi: number;
	importoAltriImpegniDiversi: number;
	idTipologia: number;
	idStatoCivile: number;
	idPosizioneLavorativa: number;
	idAltriRedditi: number;
	idRichiestaMutuo: number;
	idNucleoFamiliare: number;
	idPercettoriReddito: number;
	idDocumento: number;
	idCitta: number;
  idAltriImpegniDiversi: number;
	
	tipologia: Trascodifica;
  statoCivile: Trascodifica;
	posizioneLavorativa: Trascodifica;
	altriRedditi: Trascodifica;
	richiestaMutuo: Trascodifica;
	nucleoFamiliare: Trascodifica;
	percettoriReddito: Trascodifica;
	tipoDocumento: Trascodifica;
	citta: Comune;
	altriImpegniDiversi: Trascodifica;
	impegni: Array<RichiestaMutuoRichiedenteImpegno>;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo-richiedente.ts